import { useCurrentUser } from '@hooks/useCurrentUser'
import { Box, tss, MembersIcon } from '@ds/components'
import { ReactElement } from 'react'
import EnhancedLink from '@components/EnhancedLink'

const useStyles = tss.create(({ theme }) => ({
    link: {
        display: 'block',
        marginLeft: theme.spacing(1),
    },

    headerPromotion: {
        position: 'absolute',
        top: '100%',
        right: 0,
        display: 'flex',
        alignItems: 'center',
        padding: '5px 7px',
        borderRadius: '0 0 4px 4px',
        borderBottom: '1px solid #e6e6e6',
        backgroundColor: '#fff',
        boxShadow: '0 5px 5px -3px #e6e6e6',
        color: '#1e70a1',
    },
}))

export default function PremiumNavPromotion(): ReactElement | null {
    const currentUser = useCurrentUser().data
    const { classes } = useStyles()

    if (!currentUser || !currentUser.isPremium) {
        return null
    }

    return (
        <Box className={classes.headerPromotion}>
            <MembersIcon color="primary.main" />
            <EnhancedLink to="https://www.internations.org/invitation?ref=he_iff" className={classes.link}>
                Invite friends
            </EnhancedLink>
        </Box>
    )
}

export { PremiumNavPromotion }
